import { CryptoBundleComponent } from './pages/crypto-bundle/crypto-bundle.component';
import { SecondWithdrawComponent } from './pages/user-dash/withdraw-tab/withdraw-fiat/second-withdraw/second-withdraw.component';
import { FormatCoinAmountPipe } from '../../modules/shared/pipes/format-coin-amount.pipe';
import { FormatNumberPipe } from '../../modules/shared/pipes/format-number.pipe';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';

import { LottieModule } from 'ngx-lottie';
import { CoreModuleRoutingModule } from './core-routing.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserDashComponent } from './pages/user-dash/user-dash.component';
import { HistoryComponent } from './pages/history/history.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DepositTabComponent } from './pages/user-dash/deposit-tab/deposit-tab.component';
import { ConfirmDialogComponent } from '../../modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { UploadImageComponent } from '../../modules/shared/components/dialogs/upload-image/upload-image.component';
import { WithdrawTabComponent } from './pages/user-dash/withdraw-tab/withdraw-tab.component';
import { ReferralComponent } from './pages/referral/referral.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { QuickBarComponent } from './pages/user-dash/quick-bar/quick-bar.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { UploadIDComponent } from '../../modules/shared/components/dialogs/upload-id/upload-id.component';
import { AlertMessageComponent } from './pages/user-dash/alert-message/alert-message.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PortfolioComponent } from './pages/user-dash/portfolio/portfolio.component';
import { NgxMaskModule } from 'ngx-mask';
import { ConfirmEmailPageComponent } from './pages/confirm-email-page/confirm-email-page.component';
import { OnboardingComponent } from './pages/user-dash/onboarding/onboarding.component';
import { DetailBalanceComponent } from './pages/user-dash/detail-balance/detail-balance.component';
import { CryptoComponent } from './pages/user-dash/detail-balance/crypto/crypto.component';
import { MainBalanceComponent } from './pages/user-dash/main-balance/main-balance.component';
import { FiatComponent } from '../../modules/shared/components/fiat/fiat.component';
import { DepositCryptoComponent } from './pages/user-dash/deposit-tab/deposit-crypto/deposit-crypto.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { CryptoTabComponent } from './pages/crypto-tab/crypto-tab.component';
import { CryptoCardComponent } from './pages/crypto-tab/crypto-card/crypto-card.component';
import { WithdrawCryptoComponent } from './pages/user-dash/withdraw-tab/withdraw-crypto/withdraw-crypto.component';
import { WithdrawFiatComponent } from './pages/user-dash/withdraw-tab/withdraw-fiat/withdraw-fiat.component';
import { SecondFactorDialogComponent } from './pages/profile/second-factor-dialog/second-factor-dialog.component';
import { InvitationSnackbarComponent } from './pages/profile/invitation-snackbar/invitation-snackbar.component';
import { ReferralAlertBannerComponent } from './pages/user-dash/referral-alert-banner/referral-alert-banner.component';

import { CryptoStakingComponent } from './pages/crypto-tab/crypto-staking/crypto-staking.component';
import { CryptoExchangeComponent } from './pages/crypto-tab/crypto-exchange/crypto-exchange.component';
import { PersonalInformationComponent } from './pages/profile/personal-information/personal-information.component';
import { DocumentationComponent } from './pages/profile/documentation/documentation.component';
import { SecurityComponent } from './pages/profile/security/security.component';
import { ProfileReferralComponent } from './pages/profile/profile-referral/profile-referral.component';
import { BenefitHistoryDialogComponent } from './pages/profile/profile-referral/benefit-history-dialog/benefit-history-dialog.component';
import { ConfirmCryptoOrderComponent } from './pages/crypto-tab/crypto-card/confirm-crypto-order/confirm-crypto-order.component';
import { UserProfileComponent } from './pages/dashboard/user-profile/user-profile.component';
import { CryptoSearchBarComponent } from './pages/crypto-tab/crypto-exchange/crypto-search-bar/crypto-search-bar.component';
import { SwapComponent } from './pages/swap/swap.component';
import { CoinSelectorDialogComponent } from './pages/swap/coin-selector-dialog/coin-selector-dialog.component';
import { CryptoBalanceComponent } from './pages/user-dash/detail-balance/crypto/crypto-balance/crypto-balance.component';
import { BasicCryptoCardComponent } from './pages/crypto-tab/crypto-exchange/basic-crypto-card/basic-crypto-card.component';
import { DetailCryptoCardComponent } from './pages/crypto-tab/crypto-exchange/detail-crypto-card/detail-crypto-card.component';
import { ConfirmSwapDialogComponent } from './pages/swap/confirm-swap-dialog/confirm-swap-dialog.component';
import { SwapSuccessDialogComponent } from './pages/swap/swap-success-dialog/swap-success-dialog.component';
import { AccountsComponent } from './pages/profile/accounts/accounts.component';
import { AddAccountComponent } from './pages/profile/accounts/add-account/add-account.component';
import { PayrollComponent } from './pages/payroll/payroll.component';
import { AddEmployeeDialogComponent } from './pages/payroll/add-employee-dialog/add-employee-dialog.component';
import { CryptoBundleDetailCardComponent } from './pages/crypto-bundle/crypto-bundle-detail-card/crypto-bundle-detail-card.component';
import { BundleBalanceComponent } from './pages/user-dash/detail-balance/crypto/bundle-balance/bundle-balance.component';
import { ConfirmBundleOrderComponent } from './pages/crypto-bundle/confirm-bundle-order/confirm-bundle-order.component';
import { FiatInvestmentPopupComponent } from './pages/user-dash/main-balance/fiat-investment-popup/fiat-investment-popup.component';
import { AddCryptoAccountComponent } from './pages/profile/accounts/add-crypto-account/add-crypto-account.component';
import { AccountCardComponent } from './pages/profile/accounts/account-card/account-card.component';
import { AccountSearchBarComponent } from './pages/profile/accounts/account-search-bar/account-search-bar.component';
import { CommerceComponent } from './pages/commerce/commerce.component';
import { ActivityComponent } from './pages/history/activity/activity.component';
import { CommerceDashComponent } from './pages/user-dash/commerce-dash/commerce-dash.component';
import { ChargeFormComponent } from './pages/user-dash/commerce-dash/charge-form/charge-form.component';
import { ChargeConfirmComponent } from './pages/user-dash/commerce-dash/charge-form/charge-confirm/charge-confirm.component';
import { ChargeInfoDialogComponent } from './pages/user-dash/commerce-dash/charge-info-dialog/charge-info-dialog.component';
import { CommerceOnboardingComponent } from './pages/profile/commerce-profile/commerce-onboarding/commerce-onboarding.component';
import { MissingDataDialogComponent } from './pages/dashboard/missing-data-dialog/missing-data-dialog.component';
import { PaginatorComponent } from './pages/history/paginator/paginator.component';
import { CommerceProfileComponent } from './pages/profile/commerce-profile/commerce-profile.component';
import { CustomizationComponent } from './pages/commerce/customization/customization.component';
import { CredentialsComponent } from './pages/commerce/credentials/credentials.component';
import { ChangePasswordDialogComponent } from './pages/commerce/qr-integration/change-password-dialog/change-password-dialog.component';
import { QrIntegrationComponent } from './pages/commerce/qr-integration/qr-integration.component';
import { ChangePasswordComponent } from './pages/profile/change-password/change-password.component';
import { EditInformationComponent } from './pages/profile/personal-information/edit-information/edit-information.component';
import { ProdeComponent } from './pages/prode/prode.component';
import { ProdeTokensComponent } from './pages/prode/tokens/prode-tokens.component';
import { ProdeTokenCardsComponent } from './pages/prode/tokens/create-token/cards/prode-token-cards.component';
import { ProdeTokenComponent } from './pages/prode/tokens/token/prode-token.component';
import { ProdeGroupsComponent } from './pages/prode/groups/prode-groups.component';
import { ProdeGroupComponent } from './pages/prode/groups/prode-group/prode-group.component';
import { ProdeGroupDialogComponent } from './pages/prode/groups/prode-group-dialog/prode-group-dialog.component';
import { ProdeTokenKnockoutComponent } from './pages/prode/tokens/create-token/knockout/prode-token-knockout.component';
import { ProdeTokenConfirmationComponent } from './pages/prode/tokens/create-token/confirmation/prode-token-confirmation.component';
import { ProdeTokenCreatedComponent } from './pages/prode/tokens/create-token/token-created/prode-token-created.component';
import { ProdeTokenGroupsComponent } from './pages/prode/tokens/create-token/groups/prode-token-groups.component';
import { CreateTokenComponent } from './pages/prode/tokens/create-token/prode-create-token.component';
import { ProdeTokenDetailsComponent } from './pages/prode/tokens/prode-token-details/prode-token-details.component';
import { ReferComponent } from './pages/prode/refer/prode-refer.component';
import { ResolveTieBreakersDialogComponent } from './pages/prode/tokens/create-token/groups/resolve-tie-breakers-dialog/resolve-tie-breakers-dialog.component';
import { RankingComponent } from './pages/prode/ranking/ranking.component';
import { PromotionMessagesCarouselComponent } from './pages/dashboard/promotion-messages-carousel/promotion-messages-carousel.component';
import { GroupComponent } from './pages/group/group.component';
import { CompanyBenefitBannerComponent } from './pages/crypto-tab/crypto-card/company-benefit-banner/company-benefit-banner.component';
import { ReferralBenefitBannerComponent } from './pages/crypto-tab/crypto-card/referral-benefit-banner/referral-benefit-banner.component';
import { DocumentFlowDialogComponent } from './pages/profile/arbitrage/document-flow-dialog/document-flow-dialog.component';
import { ChoiceComponent } from './pages/profile/arbitrage/document-flow-dialog/components/choice/choice.component';
import { UploadDocumentComponent } from './pages/profile/arbitrage/document-flow-dialog/components/upload-document/upload-document.component';
import { ArbitrageComponent } from './pages/profile/arbitrage/arbitrage.component';
import { StepComponent } from './pages/profile/arbitrage/document-flow-dialog/step/step.component';
import { DcaComponent } from './pages/dca/dca.component';
import { CreateRulesComponent } from './pages/dca/create-rules/create-rules.component';
import { MyAutomationsComponent } from './pages/dca/my-automations/my-automations.component';
import { StepOneComponent } from './pages/dca/create-rules/step-one/step-one.component';
import { StepTwoComponent } from './pages/dca/create-rules/step-two/step-two.component';
import { EmptyStateComponent } from './pages/dca/my-automations/empty-state/empty-state.component';
import { RuleCardComponent } from './pages/dca/my-automations/rule-card/rule-card.component';
import { MakeTradeComponent } from './pages/group/make-trade/make-trade.component';
import { OnboardingGroupComponent } from './pages/group/onboarding-group/onboarding-group.component';
import { SelfieComponent } from './pages/profile/selfie/selfie.component';
import { QRCodeModule } from 'angularx-qrcode';
import { EditNumberDialogComponent } from './pages/profile/personal-information/edit-number-dialog/edit-number-dialog.component';

@NgModule({
  declarations: [
    DashboardComponent,
    UserDashComponent,
    HistoryComponent,
    DepositTabComponent,
    WithdrawTabComponent,
    ConfirmDialogComponent,
    ProfileComponent,
    UploadImageComponent,
    ReferralComponent,
    QuickBarComponent,
    UploadIDComponent,
    CompanyBenefitBannerComponent,
    ReferralBenefitBannerComponent,
    AlertMessageComponent,
    PortfolioComponent,
    SecondWithdrawComponent,
    ConfirmEmailPageComponent,
    OnboardingComponent,
    DetailBalanceComponent,
    CryptoComponent,
    MainBalanceComponent,
    DepositCryptoComponent,
    CryptoComponent,
    CryptoCardComponent,
    WithdrawCryptoComponent,
    WithdrawFiatComponent,
    SecondFactorDialogComponent,
    InvitationSnackbarComponent,
    ReferralAlertBannerComponent,
    CryptoStakingComponent,
    CryptoTabComponent,
    CryptoExchangeComponent,
    PersonalInformationComponent,
    DocumentationComponent,
    SecurityComponent,
    ProfileReferralComponent,
    BenefitHistoryDialogComponent,
    ConfirmCryptoOrderComponent,
    UserProfileComponent,
    CryptoSearchBarComponent,
    SwapComponent,
    CoinSelectorDialogComponent,
    CryptoBalanceComponent,
    BasicCryptoCardComponent,
    DetailCryptoCardComponent,
    ConfirmSwapDialogComponent,
    SwapSuccessDialogComponent,
    AccountsComponent,
    AddAccountComponent,
    PayrollComponent,
    AddEmployeeDialogComponent,
    CryptoBundleComponent,
    CryptoBundleDetailCardComponent,
    BundleBalanceComponent,
    ConfirmBundleOrderComponent,
    FiatInvestmentPopupComponent,
    AccountSearchBarComponent,
    AddCryptoAccountComponent,
    AccountCardComponent,
    CommerceComponent,
    ActivityComponent,
    CommerceDashComponent,
    ChargeFormComponent,
    ChargeConfirmComponent,
    ChargeInfoDialogComponent,
    CommerceOnboardingComponent,
    MissingDataDialogComponent,
    PaginatorComponent,
    CommerceProfileComponent,
    CustomizationComponent,
    CredentialsComponent,
    ChangePasswordDialogComponent,
    QrIntegrationComponent,
    ChangePasswordComponent,
    EditInformationComponent,
    ProdeComponent,
    ProdeTokensComponent,
    CreateTokenComponent,
    ProdeGroupsComponent,
    ProdeTokenKnockoutComponent,
    ProdeTokenCardsComponent,
    ProdeTokenConfirmationComponent,
    ProdeTokenCreatedComponent,
    ProdeTokenComponent,
    ProdeGroupsComponent,
    ProdeGroupComponent,
    ProdeGroupDialogComponent,
    ProdeTokenGroupsComponent,
    ProdeTokenDetailsComponent,
    ReferComponent,
    ResolveTieBreakersDialogComponent,
    RankingComponent,
    PromotionMessagesCarouselComponent,
    GroupComponent,
    DocumentFlowDialogComponent,
    ChoiceComponent,
    UploadDocumentComponent,
    ArbitrageComponent,
    StepComponent,
    DcaComponent,
    CreateRulesComponent,
    MyAutomationsComponent,
    StepOneComponent,
    StepTwoComponent,
    EmptyStateComponent,
    RuleCardComponent,
    MakeTradeComponent,
    OnboardingGroupComponent,
    SelfieComponent,
    EditNumberDialogComponent,
  ],

  imports: [
    CommonModule,
    FormsModule,
    CoreModuleRoutingModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatSortModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    MatChipsModule,
    MatProgressBarModule,
    MatExpansionModule,
    NgxChartsModule,
    NgxMaskModule.forRoot(),
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    NgxQRCodeModule,
    LottieModule,
    QRCodeModule,
  ],
  providers: [DatePipe, DecimalPipe, FormatNumberPipe, FormatCoinAmountPipe],
})
export class CoreModule {}
